import { Api } from 'api/cabmun-api-public';

export enum OlympiadStatus {
  'current' = 'current',
  'passed' = 'passed',
  'future' = 'future',
}
export interface OlympiadDetailsProps {
  status: OlympiadStatus;
  summaryBySchoolData?: TableSummaryBySchoolData[];
  summaryByTasksData?: TableSummaryByTasksData[];
}

export interface TableSummaryBySchoolData {
  municipalicy: string;
  schoolTitle?: string;
  activeStudentsCount: number;
  participantsPercent: number;
  participantsCount: number;
  prizeholdersPercent?: number;
  prizeholdersCount?: number;
}

export interface TableSummaryBySchoolProps {
  status: OlympiadStatus;
  rows?: TableSummaryBySchoolData[];
  total: OlympiadTableTotal;
  isRegionUser: boolean;
  __isRoads2211: boolean;
  olympiadId: string;
}

export interface TableSummaryByTasksData {
  difficulty: string;
  name: string;
  description: string;
  correctAnswersPercent: number;
  correctAnswersPercentRussia: number;
}

export enum SortIconState {
  inactive,
  ascending,
  descending,
}

export interface TotalStatistic {
  planned: number;
  completed: number; // (?)
  remaining: number;
  current: number;
  activeStudentsCount: number;
  medianActivity: number;
  studentsPerOlympiad: number;
  prizeholdersPercent: number;
  prizeholdersTotal: number;
}
export interface OlympiadTable {
  activeStudentsCount: number;
  participantsPercent: number;
  participantsCount: number;
  prizeholdersPercent: number;
  prizeholdersCount: number;
}
export type OlympiadTableTotal = OlympiadTable & { realStudentsCount: number | null };

export interface Olympiad {
  id: string;
  ratingByRealStudentsCount: boolean;
  name: string;
  url?: string;
  icon?: string;
  attachments?: { link: string; type: string; title: string }[];
  dates?: string;
  description?: string;
  total: OlympiadTableTotal;
  schools: ({ municipalicy: string; schoolTitle: string } & OlympiadTable)[];
  municipalities: ({ municipalicy: string } & OlympiadTable)[];
  cards: {
    difficulty: string;
    name: string;
    description: string;
    correctAnswersPercent: number;
    correctAnswersPercentRussia: number;
  }[];
  ratings?: MunicipalityRatings['ratings'];
  ratingStaticData?: { improve_button_link?: string; popup_text?: string } | null;
}

export type ReducerAction =
  | { type: 'startLoading'; key: string }
  | { type: 'errorLoading'; key: string }
  | {
      type: 'setOlympiadsByKey';
      key: string;
      data: { olympiads: Olympiad[]; ratingsByOlympiads: Api.GetMunicipalityRatingsByOlympiads200Response[] };
    };

export type MunicipalityRatings = Api.GetMunicipalityRatingsByOlympiads200Response;
